/** @format */

import React from 'react'

import { GlobalConsumer } from '../../../../components/Commons/Context/Global'
import { BagConsumer } from '../../../../components/Commons/Context/Bag'

// import BagAddress from './components/BagAddress'
import BagPriceinfo from './components/BagPriceInfo'
import BagRecipesInfo from './components/BagRecipesInfo'
import BagButtonCalculate from './components/BagButtonCalculate'

import './style.scss'

export default function BagMainInfo(props) {
	const { isMobile } = GlobalConsumer()
	const { isBagData } = BagConsumer()

	return (
		<div className='ph-bag-main-info-global-container'>
			<div className='ph-bag-main-info-main-container'>

					{/* {!isMobile && (
						<div className="ph-bag-main-info-adress-container">

							<div className="ph-bag-main-info-main-title-container">

								<span className="ph-bag-main-info-main-title"> <span style={{ fontWeight: '500'}}>Tu domicilio</span> (nos sirve para calcular si la farmacia está cerca de tu  dirección)</span>
							</div>
							<hr style={{ margin: '10px 0', borderTop: '1px #EDEDEF' }} />
							<div>
								<BagAddress isType={props.isType} classType={'ph-cart-form-address'} />
							</div>
						</div>
					)} */}
				<div>
					<BagRecipesInfo />
				</div>

				{!isMobile && (
					<div className="ph-bag-main-info-total-container">
						<div className="ph-bag-main-info-delivery-container">
							<BagPriceinfo amount={isBagData?.total} type={'primary'} title={'Total a Pagar:'} />

						</div>
						<hr style={{ margin: '10px 0', borderTop: '1px #EDEDEF' }} />
						<div className="ph-bag-main-info-button-calculate-container">
							<BagButtonCalculate cartForm={props.cartForm} />
						</div>
					</div>
				)}
			</div>
		</div>
	)
}
